import directives from '../module';
import {Utils} from '../../underscore-extensions';

class EditableCtrl implements ng.IComponentController {
    onChange: Function = this.onChange || angular.noop;
    maxlength: number = this.maxlength || 500;

    private editorEnabled = false;
    private textareaE: HTMLInputElement;
    private owner: boolean;
    private notAllowEmpty: boolean;
    private model: string;
    private prevModel: string;
    private editModel: string;
    private isEditable: string;
    private tag: string;
    private defaultMsg: string;

    constructor(private $scope: ng.IScope,
                private $element: ng.IAugmentedJQuery,
                private $filter: ng.IFilterService,
                private $timeout: ng.ITimeoutService,
                private $compile: ng.ICompileService) {
        if (this.isEditable) {
            this.enableEditor();
        }
    }

    $postLink() {
        this.textareaE = this.$element[0].querySelector('.textarea') as HTMLInputElement;
        const textEl = this.$element[0].querySelector('#text-el');

        textEl.innerHTML = textEl.innerHTML.replace(/div/, this.tag);
        this.$compile(textEl)(this.$scope);
    }

    private unEdit($event: Event) {
        this.editorEnabled = false;

        if (this.notAllowEmpty && this.editModel === '') {
            this.editModel = this.model;
        } else {
            this.model = this.$filter('stripTags')(angular.copy(this.editModel));
        }

        if (this.model === this.prevModel) {
            this.prevModel = '';
            return;
        }

        this.prevModel = this.model;
        this.$element[0].classList.remove('editing');
        if ($event != null) $event.preventDefault();
        this.onChange({$event: this.model});
        Utils.rAF(() => this.textareaE.blur());
    }

    private unEditNoSave($event: Event) {
        this.editorEnabled = false;
        this.$element[0].classList.remove('editing');
        this.editModel = this.model;
        if ($event != null) $event.preventDefault();
    }

    private enableEditor() {
        if (!this.owner) return;
        this.editModel = angular.copy(this.model);
        this.editorEnabled = true;
        this.$element[0].classList.add('editing');
        Utils.rAF(() => {
            this.textareaE.focus();
            this.textareaE.select();
            this.textareaE.setSelectionRange(0, 9999); // fix for IOS
        });
    }
}

directives.component('editable', {
    bindings: {
        'model': '=model',
        'owner': '=',
        'defaultMsg': '@',
        'tag': '@',
        isEditable: '<?',
        notAllowEmpty: '<?',
        maxlength: '<?',
        onChange: '&?'
    },
    controller: EditableCtrl,
    templateUrl: require('project/editable.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/project/editableDirective.ts